'use strict';
import HeaderTracker from '../MetricsTracker/header/metrics'
import { initializeApp } from 'firebase/app';
import { getAuth, sendPasswordResetEmail, signInWithEmailAndPassword, signInWithPopup, createUserWithEmailAndPassword, deleteUser, signOut, sendEmailVerification, GoogleAuthProvider, FacebookAuthProvider } from 'firebase/auth';
import LowPriceNotifierService from '../utils/pricetravel/shared/lowPriceNotifierService';
import GlobalUtil from '../utils/pricetravel/shared/globalUtil';
import { StorageService } from '../vue/services/StorageService'

window.app.controller('LoginController', controller);
controller.$inject = ["$scope", "$http", "$timeout", "$location", "localStorageService"];
function controller($scope, $http, $timeout, $location, localStorageService) {
    const TIEMPO_DE_EXPIRACION = 1 * 60 * 1000; // Dos minutos en milisegundos
    let loginErrors = window.__pt.settings.loginErrors;
    let modalElement = 'modal-login';
    let navLoginModal = '#navbarNav';
    let vm = this;
    let tracker = new HeaderTracker();
    let fn = window.__pt.fn;
    let paramsQuery = fn.search();
    let site = window.__pt.settings.site;
    let recaptchaNeed = 0;
    let recaptchaCall = 1;
    let config = window.__pt.settings.site;
    let cultureData = window.__pt.cultureData || {};
    let lang = window.__pt.ln;
    const configs = config.login.firebaseSettings;
    const firebaseApp = initializeApp(configs);
    vm.loginProviders = window.__pt.settings.site.login.providers;
    vm.settings = window.__pt.settings.site.login.main || {};
    vm.modalActive = false;
    vm.loadingSession = false;
    vm.loadingUserProfile = false;
    vm.dropdownListActive = false;
    vm.stepRegister = 1;
    vm.currenLink = "";
    vm.isResetpassword = false;
    vm.isProvider = false;
    vm.pageError = {};
    vm.userData = {
        email: '',
        password: '',
        pwdconfirm: '',
        lastname: '',
        name: '',
        recatcha: ''
    };
    vm.newsletter = {
        emailUser: '',
        recatcha: '',
        showError: false,
        submitCount: 0
    };
    vm.emailInvalid = false;
    vm.emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    vm.sessionData = { isLogin: false };
    vm.photoStyle = {};
    vm.currentErrorMsg = null;
    vm.showBanner = true;
    vm.currentErrorMsgPerfil = null;
    vm.avatarConf = {
        color: '',
        avatar: ''
    };
    vm.eyeUser = true;
    vm.userDataWriten = {
        name: '',
        phone: '',
        recaptchaToken: ''
    };
    vm.userProfile = {
        name: null,
        contactEmail: null,
        phone: null,
        codePhone: null,
        birthdate: null,
        nationality: null,
        placeOfResidence: null,
        gender: null,
        createdAt: null,
        updatedAt: null,
        deletedAt: null,
        usersId: 0,
        reservations: [],
        id: 0,
        uid: ""
    };
    vm.dropdown_phones = false;
    vm.dropdown_lang = false;
    vm.dropdown_langMobile = false;
    vm.dropdown_nav = false;
    vm.dropdown_tablet = false;
    vm.iscodept = false;
    vm.codeData = {};
    vm.isResendCurrenUser = false;
    vm.settingsForm = {
        redirect: "",
        language: "",
        currency: "",
        url: ""
    };


    const service = new LowPriceNotifierService(config.domainAPIUrl);
    let _paramQuery = fn.search();
    let _globalUtil = new GlobalUtil(_paramQuery, config);
    let _userKeyFavorites = _globalUtil.getUserKeyFavorites();


    vm.showModal = (modal) => {
        vm.stepRegister = 1;
        $(`#${modal}`).modal("show");
        if (modal != "modal_langcurr") {
            tracker.metricLoginAction('login', { action: "open modal" });
            tracker.metricLoginAction('login', { action: "link header" });
        }
        tracker.metricHeaderSelectContent({ title: "idioma-moneda" });
    }
    vm.showModalHeader = (modal) => {
        $(`#${modal}`).modal("show");
        vm.cleaInputs();
    }
    vm.hideModalCoupon = (modal) => {
        vm.showBanner = false;

    }
    vm.hideModalCall = (modal, form) => {
        $(`#${modal}`).modal("hide");
        vm.cleaInputs(form);
    }
    vm.cleaInputs = (form) => {
        vm.userDataWriten = {
            name: '',
            phone: '',
            recaptchaToken: ''
        };
        if (form) {
            form.$setPristine();
            form.$setUntouched();
        }
        grecaptcha.enterprise.reset();
    }
    vm.hideModal = (modal) => {
        $(`#${modal}`).modal("hide");
        tracker.metricLoginAction('login', { action: "close modal" });

    }
    vm.clickOutside = (event, modal) => {
        if (event.target.id === modal) {
            vm.hideModal(modal);
        }
    }
    vm.clickOutsideCall = (event, modal, form) => {
        if (event.target.id === modal) {
            vm.hideModalCall(modal, form);
        }
    }
    vm.submitForm = (form, modal = '') => {
        if (form.$invalid) {
            return;
        }
        switch (vm.stepRegister) {
            case 1:
                form.$setPristine();
                form.$setUntouched();
                vm.verifyEmail();
                break;
            case 2:
                vm.loginWithEmailAndPassword(form);
                break;
            case 3:
                vm.createUserWithEmailAndPassword(form);
                break;
            case 4:
                vm.recoveryPassword();
                break;
        }
    }
    vm.forgotPasswordForm = (form) => {
        vm.currentErrorMsg = "";
        form.$setPristine();
        form.$setUntouched();
        vm.recoveryPassword();
        vm.stepRegister = 4;
    }
    vm.verifyEmail = async () => {
        vm.loadingSession = true;
        const auth = getAuth(firebaseApp);
        auth.languageCode = config.language;
        try {
            const userCredential = await signInWithEmailAndPassword(auth, vm.userData.email, '/\/\/0000');
            $scope.$apply(function () {
                vm.loadingSession = false;
                vm.stepRegister = 2;
            });
        } catch (error) {
            $scope.$apply(function () {
                vm.loadingSession = false;
                //tracker.metricsErrorsLogin(error.code);
                if (error.code === 'auth/user-not-found' || error.code === 'EMAIL_NOT_FOUND') {
                    vm.stepRegister = 3;
                } else {
                    vm.stepRegister = 2;
                }
            });
        }
    };

    function onErrorUser(response, type = null) {
        vm.pageError.has = true;
        vm.pageError.type = type;
        vm.loading = false;
        vm.loadingSession = false;
    }
    vm.createUserWithEmailAndPassword = async () => {
        vm.loadingSession = true;
        const auth = getAuth(firebaseApp);
        auth.languageCode = config.language;
        try {
            const userCredential = await createUserWithEmailAndPassword(auth, vm.userData.email, vm.userData.password);
            $scope.$apply(async function () {
                const user = userCredential.user;
                vm.isResendCurrenUser = false;

                try {
                    await setSessionByProvider(user.uid, true, vm.userData.recatcha);
                    const actionCodeSettings = {
                        url: config.siteUrl + "/" + cultureData.cultureCode + '/login',
                        handleCodeInApp: true
                    };

                    try {
                        await sendEmailVerification(user, actionCodeSettings);
                        tracker.metricLoginAction('login', { action: "create account email" });
                    } catch (verificationError) {
                        $scope.$apply(function () {
                            vm.loadingSession = false;
                            vm.currentErrorMsg = loginErrors[verificationError.code] || lang.errorVerification;
                            tracker.metricsErrorsLogin(verificationError.code || vm.currentErrorMsg);
                        });
                    }
                } catch (sessionError) {
                    $scope.$apply(function () {
                        vm.loadingSession = false;
                        vm.currentErrorMsg = loginErrors[sessionError.code] || lang.errorConfigSesion;
                        tracker.metricsErrorsLogin(sessionError.code || vm.currentErrorMsg);
                    });
                }

                vm.loadingSession = false;
            });
        } catch (error) {
            $scope.$apply(function () {
                vm.loadingSession = false;
                vm.currentErrorMsg = loginErrors[error.code] || lang.errorLogin;
                tracker.metricsErrorsLogin(error.code || vm.currentErrorMsg);
                vm.stepRegister = 3;
            });
        }
    };

    vm.goToStepOne = () => {
        vm.stepRegister = 1;
        vm.currentErrorMsg = "";
    }
    $scope.$watch('vm.stepRegister', function (newValue) {
        if (window.grecaptcha && newValue == 3) {
            grecaptcha.ready(function () {
                grecaptcha.render("g-recaptcha-login", {
                    sitekey: "6LdVzyYoAAAAAArBDZLZ-upafYoaZAxNT_iCpjGx",
                    callback: function (response) {
                        $scope.$apply(function () {
                            iniciarTemporizadorDeTokenRecaptcha();
                            vm.userData.recatcha = response;
                        });
                    }
                });
            });
        }
    });
    vm.loginWithEmailAndPassword = async () => {
        vm.loadingSession = true;
        const auth = getAuth(firebaseApp);
        auth.languageCode = config.language;
        try {
            const userCredential = await signInWithEmailAndPassword(auth, vm.userData.email, vm.userData.password);
            $scope.$apply(async function () {
                const user = userCredential.user;
                if (user.emailVerified) {
                    setSessionByProvider(user.uid, false);
                    tracker.metricLoginAction('login', { action: "login email" });
                    vm.loadingSession = false;
                } else {
                    vm.isResendCurrenUser = true;
                    tracker.metricsErrorsLogin("Not emailVerified");
                    const userCurrent = auth.currentUser;
                    try {
                        await sendEmailVerification(userCurrent);
                    } catch (error) {
                        $scope.$apply(function () {
                            vm.loadingSession = false;
                            vm.currentErrorMsg = loginErrors[error.code] || lang.errorVerification;
                            tracker.metricsErrorsLogin(error.code || vm.currentErrorMsg);
                            vm.stepRegister = 2;
                        });
                    }
                    vm.logout(true);
                    vm.stepRegister = 7;
                    vm.loadingSession = false;
                }
            });
        } catch (error) {
            $scope.$apply(function () {
                vm.loadingSession = false;
                vm.currentErrorMsg = loginErrors[error.code] || lang.errorLogin;
                tracker.metricsErrorsLogin(error.code || vm.currentErrorMsg);
                vm.stepRegister = 2;
            });
        }
    };

    vm.loginWithProvider = async (providerType) => {
        vm.loadingSession = true;
        const auth = getAuth(firebaseApp);
        auth.languageCode = config.language;
        let provider;

        switch (providerType) {
            case "Google":
                provider = new GoogleAuthProvider();
                break;
            case "Facebook":
                provider = new FacebookAuthProvider();
                break;
            default:
                console.error("Proveedor no admitido");
                vm.loadingSession = false;
                return;
        }

        try {
            const result = await signInWithPopup(auth, provider);
            $scope.$apply(function () {
                const user = result.user;
                setSessionByProvider(user.uid, false);
                tracker.metricLoginAction('login', { action: `login ${providerType}` });
                vm.loadingSession = false;
            });
        } catch (error) {
            $scope.$apply(function () {
                vm.currentErrorMsg = loginErrors[error.code] || lang.errorLogin;
                tracker.metricsErrorsLogin(error.code || lang.errorLogin);
                vm.stepRegister = 1;
                vm.loadingSession = false;
            });
        }
    };

    vm.deleteAccount = () => {
        const auth = getAuth();
        auth.languageCode = config.language;
        const user = auth.currentUser;

        if (user) {
            deleteUser(user)
                .then(() => {
                    $scope.$apply(() => {
                        tracker.metricLoginAction('login', { action: 'delete account' });
                        vm.logout();
                    });
                })
                .catch((error) => {
                    $scope.$apply(() => {
                        vm.currentErrorMsg = lang.errorDeletingAccount + (error.code || lang.errorLogin);
                        tracker.metricsErrorsLogin(error.code || lang.errorDeletingAccount);
                    });
                });
        } else {
            $scope.$apply(() => {
                vm.currentErrorMsg = lang.noUserLoggedIn;
            });
        }
    };

    vm.recoveryPassword = async () => {
        vm.loadingSession = true;
        const auth = getAuth(firebaseApp);
        auth.languageCode = config.language;
        const actionCodeSettings = {
            url: config.siteUrl + "/" + cultureData.cultureCode +'/login',
            handleCodeInApp: true
        };
        try {
            await sendPasswordResetEmail(auth, vm.userData.email, actionCodeSettings);
            $scope.$apply(() => {
                vm.loadingSession = false;
                tracker.metricLoginAction('login', { action: `forgot password` });
            });
        } catch (error) {
            $scope.$apply(() => {
                tracker.metricsErrorsLogin(error.code || lang.errorSendingPasswordResetEmail);
                vm.currentErrorMsg = loginErrors[error.code] || lang.errorLogin;
                vm.loadingSession = false;
            });
        }
    };

    vm.logout = async (skip = false) => {
        const auth = getAuth(firebaseApp);
        auth.languageCode = config.language;
        try {
            await signOut(auth);
            $scope.$apply(() => {
                vm.sessionData = { isLogin: false };
                tracker.metricLoginAction('login', { action: 'sign out' });
                if (!skip) {
                    document.getElementById('logout-form').submit();
                }
            });
        } catch (error) {
            $scope.$apply(() => {
                vm.currentErrorMsg = lang.errorSigningOut + (error.code || lang.errorLogin);
                tracker.metricsErrorsLogin(error.code || lang.errorSigningOut);
            });
        }
    };

    vm.reseendVerification = async () => {
        vm.loadingSession = true;
        const auth = getAuth(firebaseApp);
        auth.languageCode = config.language;
        const user = auth.currentUser;
        try {
            await sendEmailVerification(user);
            $scope.$apply(() => {
                vm.loadingSession = false;
            });
        } catch (error) {
            $scope.$apply(() => {
                vm.loadingSession = false;
                vm.currentErrorMsg = lang.errorResendingVerificationEmail + (error.code || lang.errorLogin);
                tracker.metricsErrorsLogin(error.code || lang.errorResendingVerificationEmail);
            });
        }
    };

    vm.continueHome = () => {
        vm.logout();
        window.location.href = '/';
    }
    vm.isActive = function (viewLocation) {
        return $location.path() === viewLocation;
    };
    vm.setSessionDataObject = (user) => {

        let name = user.userProfile.name || "";

        vm.sessionData = {
            token: user.token,
            displayName: name.split(' ')[0] || user.userProfile.contactEmail,
            uid: user.firebaseId,
            photoURL: user.image,
            isLogin: true,
        };

        vm.userProfile.name = user.userProfile.name || null;
        vm.userProfile.uid = user.firebaseId || null;
        vm.userProfile.contactEmail = user.userProfile.contactEmail || null;
        vm.userProfile.phone = user.userProfile.phone || null;
        vm.userProfile.codePhone = user.userProfile.codePhone || null;
        vm.userProfile.birthdate = user.userProfile.birthdate || null;
        vm.userProfile.nationality = user.userProfile.nationality || null;
        vm.userProfile.placeOfResidence = user.userProfile.placeOfResidence || null;
        vm.userProfile.gender = user.userProfile.gender || null;
        vm.userProfile.createdAt = user.userProfile.createdAt || null;
        vm.userProfile.updatedAt = user.userProfile.updatedAt || null;
        vm.userProfile.deletedAt = user.userProfile.deletedAt || null;
        vm.userProfile.usersId = user.userProfile.usersId || 0;
        vm.userProfile.reservations = user.reservation || [];
        vm.userProfile.id = user.id || 0;
        vm.avatarConf.avatar = vm.userProfile.name ? vm.userProfile.name.substr(0, 1) : vm.userProfile.contactEmail.substr(0, 1);
        vm.avatarConf.color = getColorDynamic();
        vm.setStyleAvatar(vm.sessionData.photoURL, vm.avatarConf);
        StorageService.set("user", vm.sessionData)
    }
    vm.setStyleAvatar = (avatar, conf) => {
        vm.photoStyle = {
            "background-position": "center center",
            "background-size": "cover",
            "background-repeat": "no-repeat",
            "background-color": "rgb(" + conf.color + ")"
        };
        if (avatar) {
            vm.photoStyle["background-image"] = "url(" + avatar + ")";
        }
    }
    vm.onClosedBanner = (idModal) => {
        var modalElement = angular.element(document.querySelector(`#${idModal}`));
        if (modalElement) {
            modalElement.css('display', 'none');
            fn.getCookie("bannerClosed", "true", 3);
        }
    }

    vm.isBannerClosed = () => {
        var bannerClosed = fn.getCookie("bannerClosed")
        return bannerClosed === "true";
    };

    vm.hasError = (form, property) => {
        let input = form[property];
        return form.$submitted && input.$invalid;
    }
    //funcione del login
    vm.isPasswordValid = function (password) {
        return password?.length >= 8 && vm.containsUppercase(password) && vm.containsNumber(password);
    };

    vm.containsUppercase = function (password) {
        return /[A-Z]/.test(password);
    };

    vm.containsNumber = function (password) {
        return /[0-9]/.test(password);
    };

    vm.submitFormtWrite = (form) => {
        vm.userDataWriten.recaptchaToken = grecaptcha.enterprise.getResponse(recaptchaCall).length > 0 ? grecaptcha.enterprise.getResponse(recaptchaCall) : null;
        form.$invalid = vm.userDataWriten.recaptchaToken ? false : true;
        if (!form.$invalid && vm.userDataWriten.phone && vm.userDataWriten.name) {
            submitWriten(vm.userDataWriten, form);
        }
    }

    async function submitWriten(form, formOriginal) {
        const rawResponse = await fetch(config.endPoints.contactCallUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(form)
        });
        vm.hideModalCall('modal-call', formOriginal);
        vm.showModalHeader('modal-confirmation', null);
    }

    vm.checkLoginParams = () => {
        let loginOpen = paramsQuery.loginOpen;
        let loginEmail = paramsQuery.loginEmail;
        let loginTimeout = paramsQuery.loginTimeout || vm.settings.timeOpen;
        if (vm.settings.autoOpen && loginOpen) {
            $timeout(() => {
                vm.showModal(modalElement);
                $(navLoginModal).addClass('show');
            }, loginTimeout * 1000);
        }
        if (loginEmail) {
            vm.userData.email = loginEmail;
        }
    }
    vm.sendContentHeader = (title) => {
        tracker.metricHeaderSelectContent({ title });
    }
    vm.openDropdown = (dropdown, opt = false) => {
        vm[dropdown] = !vm[dropdown];
        if (vm[dropdown] && dropdown === 'dropdown_nav') {
            disableBodyScroll();
        } else {
            enableBodyScroll();
        }

        if (dropdown !== 'dropdown_nav') {
            //  disableBodyScroll(); 
        }
        if (!vm['dropdown_user'] && dropdown === 'dropdown_user') {
            // enableBodyScroll(); 
        }
        if (dropdown != 'dropdown_nav' && window.innerWidth <= 991) {
            vm.dropdown_nav = false;
        }
        if (site.mobile && vm[dropdown] && opt) {
            return
        }

        vm.setDatePopupLogin();
    }
    vm.openDropdownClose = (dropdown, opt = false) => {
        vm[dropdown] = false;
    }
    vm.setDatePopupLogin = () => {

        let isDayPassed = StorageService.get("popup_auto_open")

        if (fn.getDate(isDayPassed) > fn.getDate()) {
            return;
        }

        let date = fn.getDate();
        date.setDate(date.getDate() + 1);
        StorageService.set("popup_auto_open", date);
    }


    /**** 
     * 
     * Currency and language section
     */

    vm.onSubmitSettingsForm = (form) => {
        let currencyChange = vm.settingsForm.url.length;
        let redirectChange = vm.settingsForm.redirect.length;

        if (currencyChange || redirectChange) {
            let query = location.search;
            let actionUrl = currencyChange ? `${vm.settingsForm.url}${query}` : `${vm.settingsForm.redirect}${query}`;
            let formElement = document.createElement("form");
            formElement.setAttribute("method", "GET");
            formElement.setAttribute("action", actionUrl);
            tracker.metricHeaderSelectContentLanguageModal({ title: "idioma_moneda" });

            if (redirectChange && !currencyChange) {
                let query = new URLSearchParams(location.search);
                query.forEach((value, key) => {
                    let hiddenField = document.createElement("input");
                    hiddenField.setAttribute("type", "hidden");
                    hiddenField.setAttribute("name", key);
                    hiddenField.setAttribute("value", value);
                    formElement.appendChild(hiddenField);
                });
            }

            if (redirectChange && currencyChange) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", `redirect`);
                hiddenField.setAttribute("value", `${vm.settingsForm.redirect}${query}`);
                formElement.appendChild(hiddenField);
            }
            $("#loader-page").removeClass("d-none");
            document.body.appendChild(formElement);
            formElement.submit();

        }


        $("#modal_langcurr").modal("hide");
    }

    vm.onChangeSettings = (property, value) => {
        vm.settingsForm[property] = value;

        const cutURLCurrency = vm.settingsForm["currency"].split('/');
        const valueCurrency = cutURLCurrency[cutURLCurrency.length - 1];

        const cutURLLanguage = vm.settingsForm["language"].split('/');
        const valueLanguage = cutURLLanguage[cutURLLanguage.length - 1];

        tracker.metricHeaderSelectModalOption({ title: property, currency: valueCurrency, language: valueLanguage });
        const mapping = {
            language: "redirect",
            currency: "url",
        };

        if (mapping[property]) {
            vm.settingsForm[mapping[property]] = value;
        }
    };
    vm.sendEmailNewsletter= async () => {
        try {
            vm.newsletter.submitCount += 1
            let recaptchaRes = grecaptcha.enterprise.getResponse(recaptchaNeed).length > 0;
            if (isEmail(vm.newsletter.emailUser)) {
                vm.newsletter.showError = false;
                if (recaptchaRes) {
                    vm.newsletter.submitCount = 0;
                    const data = {
                        "apiKey": "ayyo9d",
                        "userKey": localStorageService.get('userKey'),
                        "email": vm.newsletter.emailUser,
                        "domain": location.host,
                        "timezone": fn.getDate().getTimezoneOffset(),
                        "resolution": `${window.screen.width}x${window.screen.height}`,
                        "url": location.href,
                        "referrer": document.referrer || "",
                        "widget_ready": true
                    };
                    tracker.newsLetter( vm.newsletter.emailUser);
                    $http.post("https://tiquetesbaratos.user.com/api/v2/user-chatping/", data).then(async (response) => {
                        vm.newsletter.showError = false;
                        vm.newsletter.emailUser = "";
                        grecaptcha.enterprise.reset();
                        vm.newsletter.submitCount = 0;
                    });
                }
            } else {
                vm.newsletter.showError = true;
            }
        } catch (err) {
            console.log(err);
        }
    }

    /****
     * 
     * 
     */

    function init() {
        let codept = paramsQuery.coupon;

        var codeptFromCookie = fn.getCookie("codept");
        var finalCodept = codept || codeptFromCookie;

        fn.setCookie("codept", finalCodept, "1");

        vm.iscodept = finalCodept ? true : false;
        if (vm.iscodept) {
            fetchCouponData(finalCodept);
        }
        if (window.__pt.settings.site.login && window.__pt.settings.site.login.main.active) {
            // vm.checkLoginParams();

            if (isSessionValid() && window.__pt.user) {
                vm.setSessionDataObject(window.__pt.user);
                if (window.location.pathname == cultureData.cultureCode + "/login") {
                    window.location.href = '/' + cultureData.cultureCode;
                }
            } else {
                if (window.location.pathname == ("/login/perfil" || cultureData.cultureCode + "/login/perfil")) {
                    window.location.href = cultureData.cultureCode +'/login';
                }
            }
        }
        if (site.siteName == "tiquetesbaratos" && window.grecaptcha && window.__pt.settings.page != "login" ) {
            grecaptcha.enterprise.ready(function () {
                const recaptchaContainer = document.getElementById('g-recaptcha-newsletter');
                if (recaptchaContainer) {
                    const recaptchaIframe = recaptchaContainer.querySelector('iframe');
                    if (!recaptchaIframe) {
                        recaptchaNeed = grecaptcha.enterprise.render("g-recaptcha-newsletter", {
                            sitekey: "6Lfl5-8eAAAAAECHbOBAyrnsbQah1X5kthYKYyvq",
                            callback: function (response) {
                                $scope.$apply(function () {
                                    iniciarTemporizadorDeTokenRecaptchaTB();
                                    vm.newsletter.recatcha = response;
                                });
                            }
                        });
                    }
                } else {
                   
                }
            });
            
             grecaptcha.enterprise.ready(function () {
                const recaptchaIframe = document.querySelector('#g-recaptcha iframe');
                    if (!recaptchaIframe) {
                        recaptchaCall = grecaptcha.enterprise.render("g-recaptcha", {
                            sitekey: "6Lfl5-8eAAAAAECHbOBAyrnsbQah1X5kthYKYyvq"
                        });
                    }
            });
        }

        if (cultureData.cultureCode === "es-mx" && !vm.loadingSession) {

            //Validar si el popup ha sido cerrado por el usuario en las ultimas 24 horas
            let isDayPassed = StorageService.get("popup_auto_open");
            if (fn.getDate() > fn.getDate(isDayPassed)) {
                vm.dropdown_user = true

                const hideLoginPopup = setTimeout(() => {

                    if (vm.dropdown_user) {
                        $("#btn_start_session").click();
                    }

                    clearTimeout(hideLoginPopup);
                }, 10000);
            }


        }

    }
    function isSessionValid() {
        var sessionCookie = fn.getCookie("session_token");
        if (sessionCookie && sessionCookie.length > 0) {
            return true;
        }
        return false;
    }
    function getColorDynamic() {
        let colorStorage = StorageService.get('user_color')
        if (!colorStorage) {
            let colors = ['#55c1ee', '#5473b7', '#5492cc', '#fbac00', '#fe6900', '#ea0074', '#573d95'];
            colorStorage = colors[Math.floor(Math.random() * colors.length)];
            StorageService.set('user_color', colorStorage)
        }
        return colorStorage;
    }

    function fetchCouponData(codeptValue) {
        $http.get(`/v1/api/GetCoupon?DiscountCode=${codeptValue}`).then((res) => {
            if (res.data != "null") {
                vm.codeData = res.data;
            } else {
                vm.codeData = {};
            }
        }).catch((error) => {
            console.error("Error al obtener los datos del cupón:", error);
            vm.codeData = {};
        });
    }

    function disableBodyScroll() {
        document.body.style.overflow = 'hidden';
    }

    function enableBodyScroll() {
        document.body.style.overflow = 'auto';
    }

    $timeout(function () {
        var menuContainer = angular.element(".bottom__container");
        var previousScrollLeft = menuContainer.scrollLeft();
        var bottomMaskLeft = angular.element(".bottom__mask--left");
        bottomMaskLeft.hide();
        menuContainer.bind("scroll", function () {
            $timeout(function () {
                var currentScrollLeft = menuContainer.scrollLeft();

                if (currentScrollLeft > previousScrollLeft) {
                    hideMasksIfOverflow("right");

                } else if (currentScrollLeft < previousScrollLeft) {
                    hideMasksIfOverflow("left");
                }

                previousScrollLeft = currentScrollLeft;
            });
        });
    });

    function hideMasksIfOverflow(direction) {
        var menuContainer = angular.element(".bottom__container");
        var firstTab = angular.element(".bottom__tab").eq(0);
        var tabRightPosition = firstTab.position().left + firstTab.outerWidth();
        var bottomMaskLeft = angular.element(".bottom__mask--left");
        var bottomMaskRight = angular.element(".bottom__mask--right");

        if (direction === "left" && tabRightPosition < 0) {
            bottomMaskLeft.hide();

        } else {
            if (tabRightPosition > 70) {
                bottomMaskLeft.hide();
            } else {
                bottomMaskLeft.show();
            }
        }

        var lastTab = angular.element(".bottom__tab").last();
        var tabLeftPosition = lastTab.position().left;

        if (direction === "right" && tabLeftPosition + lastTab.outerWidth() > menuContainer.width()) {
            bottomMaskRight.hide();
        } else {
            bottomMaskRight.show();
        }
        if (angular.element(".bottom__tab").eq(0).position().left < 0) {

        }
        var lastTab = angular.element(".bottom__tab").last();
        var lastTabRightPosition = lastTab.position().left + lastTab.outerWidth();
        if (lastTabRightPosition > menuContainer.width()) {

            bottomMaskRight.show();
        }
    }


    init();
    async function setSessionByProvider(uid, notsession, token) {
        vm.loadingSession = true;
        let headers = {
            headers: {
                "X-XSRF-TOKEN": getCSFRToken()
            }
        }
        var requestData = {
            uid: uid,
            notSession: notsession,
            name: vm.userData.name,
            lastname: vm.userData.lastname,
            token: token || uid,
            remember: true,
            culture: cultureData.cultureCode
        };


        $http.post(config.siteUrl + "/hotel/api/login", requestData, headers).then(async (response) => {
            vm.loadingSession = false;
            if (response.data.status == 200) {
                if (notsession) {
                    vm.stepRegister = 7;
                } else {
                    const request = { UserId: _userKeyFavorites, FirebaseId: requestData.uid, country: config.country.toUpperCase() };
                    
                    await service.copyByUser(request).then(response => {
                    }).catch(error => {
                        console.error('Error fetching copyByUser:', error);
                    });
                    if (paramsQuery.redirectTo && paramsQuery.redirectTo !== "") {
                        window.location.href = config.siteUrl  + paramsQuery.redirectTo;
                    } else {
                        window.location.href = config.siteUrl  + "/" + cultureData.cultureCode + "/";
                    }

                }
            } else {
                vm.currentErrorMsg = response.data.response;
                vm.stepRegister = 1;
            }
        }, onErrorUser);

    }
    function iniciarTemporizadorDeTokenRecaptchaTB() {
        setTimeout(function () {
            $scope.$apply(function () {
                vm.newsletter.recatcha = "";
            });
        }, TIEMPO_DE_EXPIRACION);
    }
    function iniciarTemporizadorDeTokenRecaptcha() {
        setTimeout(function () {
            $scope.$apply(function () {
                vm.userData.recatcha = ""; 
            });
        }, TIEMPO_DE_EXPIRACION);
    }
    function isSessionValid() {
        var sessionCookie = fn.getCookie("session_token");
        if (sessionCookie && sessionCookie.length > 0) {
            return true;
        }
        return false;
    }

    function getCSFRToken() {
        let csfr = document.querySelector("[name='_token']");
        return csfr ? csfr.value : "";
    }
    function isEmail(value) {
        if (value.length === 0) {
            return false;
        } 
        const re = /\S+@\S+\.\S+/;
        return re.test(value);
    }

}
